export const STORE_LINKAGE_TYPES = {
  SENDER: 'sender',
  RECIPIENT: 'recipient',
  BOTH: 'both',
};
